<template>
  <b-navbar type="dark" variant="theme" toggleable="lg">
    <b-navbar-brand href="http://linkdsg.com/" target="_blank">
      <img src="@/assets/brand/logo2.png" height="45" />
    </b-navbar-brand>

    <b-nav-text class="ml-1  text-white" style="font-size:12px;">
      North America: (888) 406-9091<br />
      UK: 0844 3240986 <br />
      <span style="font-size:10px;">
        <a href="http://linkdsg.com/about-us/contact-us"
          >More contact information >
        </a></span
      >
    </b-nav-text>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse class="text-white" id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto" v-if="profile.name">
        <b-nav-text
          class="d-flex"
          style="color:#fff;font-style:italic;font-size:12px;"
          v-if="profile"
        >
          <span calss="text-center">
            Welcome to {{ profile.account }}/{{ profile.site }}
            <br />
            {{ profile.name }}
            <br />
            <span class="text-center">
              {{ profile.role }}
              <!-- <b-img :src="SAShield" v-else-if="authType === 'c'" /> -->
            </span>
          </span>
        </b-nav-text>
        <b-nav-item-dropdown right v-if="profile">
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <!-- <em class="text-light" v-if="profile.firstName.length > 0"
              >Welcome {{ profile.firstName }} {{ profile.lastName }}</em
            >
            <em class="text-light" v-else>Welcome {{ profile.UserName }}</em> -->
            <em>
              <b-img
                :src="AccountIcon"
                fluid
                style="max-width:35px;"
                v-if="isAllowed === 'c'"
              />
              <b-img
                :src="SAShield"
                v-else-if="isAllowed === 'sa'"
                fluid
                style="max-width:25px;"
              />

              <b-img
                :src="CAShield"
                v-else-if="isAllowed === 'ca'"
                fluid
                style="max-width:25px;"
              />
              <!-- <b-img
                class="shield"
                :src="SAShield"
                v-if="isAllowed === 'sa'"
                fluid
                style="max-width:25px;"
              />

              <b-img
                class="shield"
                :src="CAShield"
                v-else-if="isAllowed === 'ca'"
                fluid
                style="max-width:25px;"
              /> -->
            </em>
          </template>
          <!-- <b-dropdown-item to="/admin">Account</b-dropdown-item> -->
          <b-dropdown-item
            :to="{
              name: 'profile'
            }"
          >
            Profile
          </b-dropdown-item>
          <!-- <b-dropdown-item to="/admin" v-if="isAllowed === 'sa'">
            System
          </b-dropdown-item> -->
          <b-dropdown-item @click="onLogoutClick">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import AccountIcon from "@/assets/account.png";
import SAShield from "@/assets/img/sa-shield.png";
import CAShield from "@/assets/img/ca-shield.png";
export default {
  data() {
    return {
      AccountIcon,
      SAShield,
      CAShield
    };
  },
  computed: {
    profile() {
      return this.$store.getters["user/proFile"];
    },
    isAllowed() {
      return this.$store.getters["user/authType"];
    },
    isInternal() {
      return this.$store.getters["user/isInternal"];
    },
    isAdmin() {
      return this.$store.getters["user/isAdmin"];
    }
  },
  methods: {
    onLogoutClick() {
      debugger;
      this.$store.dispatch("user/logout").then(() => (window.location = "/"));
      // this.logout().then(() => (window.location = "/"));
    }
  }
};
</script>

<style scoped>
.shield {
  position: absolute;
  margin-left: 26%;
  margin-top: 47%;
}
</style>



// WEBPACK FOOTER //
// src/components/NavMain.vue